/*
A feature is an object with the following properties:
    @id: identifier of the feature
    @criteria: array with the criteria that applies

    e.g. {
        id: 'new-feature',
        criteria: [{ 'isEnabledForDevUsers': true }]
    }
*/

export const features = [
    {
        id: 'hidden-dynamic-categories',
        criteria: [{ isEnabledForDevUsers: true }]
    },
    {
        id: 'vat-in-connection-modal',
        criteria: [{ needsVatInConnectModal: true }]
    },
    {
        id: 'stock-allocation',
        criteria: [
            { isEnabledForDevUsers: true },
            { isEnabledForCavani: true },
            { isEnabledForAngels: true },
            { isEnabledForGstar: true },
            { isEnabledForFunkyBuddha: true }
        ]
    },
    {
        id: 'download-content-data',
        criteria: [{ isEnabledForContentDevUsers: true }]
    },
    {
        id: 'last-ordered-articles',
        criteria: [{ isEnabledForContentDevUsers: true }]
    },
    {
        id: 'show-b2c-link',
        criteria: [{ isEnabledForVanBommelShop: true }]
    },
    {
        id: 'download-settings',
        criteria: [{ isEnabledForDevUsers: true }]
    },
    {
        id: 'brand-insights',
        criteria: [{ isInsightsEnabledForManufacturer: true }]
    },
    {
        id: 'sub-seasons-filter',
        criteria: [{ isEnabledForStudioAnneloes: true }]
    }
];
